module.exports = __webpack_public_path__ + "static/img/college.47f7ab0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rencai/college.jpg
// module id = FwSj
// module chunks = 2